import $ from 'jquery';
import LunchMenuView from '../views/LunchMenuView';
import LunchMenu from '../models/LunchMenu';
import {getLunchById} from '../data-utils';
import action from '../action';

function start(context) {
  var params = LunchMenu.init(context);
  if($.isEmptyObject(params)){
    params = LunchMenu.init();
  }
  render(params);
}

function refresh(){
  var params = LunchMenu.getLunchList();
  render(params);
}

function render(params){
  LunchMenuView.render(params);
  bindEvents(params);
  setLunchListPosition(params);
}

function setLunchListPosition(params){
  var menuContainer = $('.lunch-list-wrapper');
  menuContainer.scrollTop(params.lastMenuViewPosition);
  var restaurantsContainer = $('.storelist__container');
  restaurantsContainer.scrollTop(params.lastRestaurantsViewPosition);
}

function bindEvents(params){
  $('#backbutton').on('mouseup touchend', function(){
    LunchMenu.goBack();
  });

  $('#lunchsortby .btn--toggle').on('mouseup touchend', function(){
    LunchMenu.setLunchSortBy(this.id);
    LunchMenu.resetLastPosition();
    refresh();
  });

  $('.storelist .list__item, .lunch-show-more-button').on('click', function() {
    const lunch = getLunchById(this.id);
    LunchMenu.getLunchList().lunch = lunch;
    LunchMenu.updateLastRestaurantsViewPosition($('.storelist__container').scrollTop(), params.currentLang);
    LunchMenu.updateLastMenuViewPosition($('.lunch-list-wrapper').scrollTop(), params.currentLang);
    refresh();
  });

  $('.close,.redirect-popup-overlay').on('click' , function(){
    LunchMenu.getLunchList().lunch = '';
    LunchMenu.getLunchList().showNoContentDialog = false;
    refresh();
  });

  $('.redirect-store-own').on('click', function() {
    LunchMenu.getLunchList().lunch = null;
    refresh();
    action.showStoreInfo(this.id);
  });

  $('.redirect-map').on('click', function () {
    LunchMenu.getLunchList().lunch = null;
    refresh();
    action.showStoreOnMap(this.id);
  });
}

export default {
  start,
  refresh,
  render,
  bindEvents
};
